import React, { useState, useEffect, useMemo } from "react";

const ClosingBalancesGrid = ({ columnsData, columnDetail }) => {
  const [expandedCurrencies, setExpandedCurrencies] = useState(new Set());

  const toggleCurrency = (currency) => {
    setExpandedCurrencies(prev => {
      const newSet = new Set(prev);
      if (newSet.has(currency)) {
        newSet.delete(currency);
      } else {
        newSet.add(currency);
      }
      return newSet;
    });
  };

  const columns = Object.keys(columnDetail).map(originalKey => {
    const detail = columnDetail[originalKey];
    return {
      key: originalKey,
      header: detail.title || originalKey,
      width: detail.width || 'auto',
      align: originalKey === 'Currency' ? 'left' : 'right'
    };
  });

  const groupedData = useMemo(() => {
    const groups = columnsData.reduce((acc, row) => {
      if (!acc[row.Currency]) acc[row.Currency] = [];
      acc[row.Currency].push(row);
      return acc;
    }, {});

    Object.keys(groups).forEach(currency => {
      groups[currency].sort((a, b) => {
        if (a.Type === b.Type) return 0;
        if (a.Type === 'Foreign') return -1;
        if (b.Type === 'Foreign') return 1;
        return String(a.Type).localeCompare(String(b.Type));
      });
    });

    return groups;
  }, [columnsData]);

  const currencies = useMemo(() => Object.keys(groupedData), [groupedData]);

  useEffect(() => {
    setExpandedCurrencies(new Set(currencies));
  }, [currencies]);

  return (
    <div style={{ height: "80vh", overflow: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col.key} style={{ border: "1px solid #ddd", padding: "8px", textAlign: col.align, width: col.width }}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currencies.map(currency => {
            const rows = groupedData[currency];
            const isExpanded = expandedCurrencies.has(currency);
            const headerRow = { Currency: currency };
            const detailRows = rows;

            return (
              <React.Fragment key={currency}>
                <tr
                  onClick={() => toggleCurrency(currency)}
                  style={{ cursor: "pointer", backgroundColor: "#f0f0f0", fontWeight: "bold" }}
                >
                  <td colSpan={columns.length} style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                    {isExpanded ? "▼" : "▶"} {headerRow.Currency}
                  </td>
                </tr>
                {isExpanded && detailRows.map((row, index) => (
                  <tr key={`${currency}-${index}`}>
                    {columns.map(col => (
                      <td key={col.key} style={{ border: "1px solid #ddd", padding: "8px", textAlign: col.align, width: col.width }}>
                        {col.key === 'Currency' ? '' : (row[col.key] === 0 ? '' : row[col.key])}
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ClosingBalancesGrid;